import React, { FC, useState } from "react";
import { useHistory } from "react-router";
import { Button, Checkbox, Col, DatePicker, Form, Input, Row, Select, Table, Tooltip } from "antd";
import { displayFormat, toHttpFormat } from "../../lib/utils/formatDate";
import { DictionaryDto } from "../../lib/interfaces/DictionaryDto";
import UploadFileDialog from "./UploadFileDialog";
import {
  CreateTemplate,
  NewDocumentTemplate,
  UploadedTemplateFile,
} from "../../lib/interfaces/DocumentTemplate";

interface IProps {
  reportType: DictionaryDto[];
  acceptedFileTypes: string[];
  createTemplate: CreateTemplate;
}

const CreateDocumentTemplate = ({ reportType, acceptedFileTypes, createTemplate }: IProps) => {
  const history = useHistory();
  const [form] = Form.useForm();
  const [uploadedFile, setUploadedFile] = useState<File | null>(null);

  const getRequiredTitle = (field) => <span className="required-title">{field}</span>;

  const columns = [
    {
      key: "defaultTemplate",
      render: () => (
        <Tooltip title="Шаблон по умолчанию">
          <Form.Item
            name="defaultTemplate"
            valuePropName="checked"
            // eslint-disable-next-line react/jsx-boolean-value
            initialValue={true}
          >
            <Checkbox />
          </Form.Item>
        </Tooltip>
      ),
      width: "3%",
    },
    {
      title: getRequiredTitle("Наименование"),
      key: "name",
      render: () => (
        <Form.Item name="name" rules={[{ required: true, message: "" }]}>
          <Input placeholder="Введите наименование" />
        </Form.Item>
      ),
      // width: "20%",
    },
    {
      title: getRequiredTitle("Тип"),
      key: "reportTypeId",
      render: () => (
        <Form.Item name="reportTypeId" rules={[{ required: true, message: "" }]}>
          <Select style={{ width: "100%" }}>
            {reportType.map(({ id, name }) => (
              <Select.Option key={id} value={id}>
                {name}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
      ),
      width: "15%",
    },
    {
      title: "Комментарий",
      key: "dsc",
      render: () => (
        <Form.Item name="dsc" initialValue="">
          <Input placeholder="Введите текст" />
        </Form.Item>
      ),
      width: "15%",
    },
    {
      title: getRequiredTitle("Период c"),
      key: "fromDate",
      render: () => (
        <Form.Item name="fromDate" rules={[{ required: true, message: "" }]}>
          <DatePicker format={displayFormat} />
        </Form.Item>
      ),
      width: "10%",
    },
    {
      title: "До",
      key: "toDate",
      render: () => (
        <Form.Item name="toDate">
          <DatePicker format={displayFormat} />
        </Form.Item>
      ),
      width: "10%",
    },
    {
      key: "file",
      render: () => (
        <Form.Item>
          <UploadFileDialog
            acceptedFileTypes={acceptedFileTypes}
            fileExists={Boolean(uploadedFile)}
            setFile={(file) => {
              setUploadedFile(file);
            }}
            fileChangedTitle="Файл заменен"
          />
        </Form.Item>
      ),
      width: "5%",
    },
  ];

  const onFinish = (values: NewDocumentTemplate) => {
    createTemplate({
      ...values,
      fromDate: toHttpFormat(values.fromDate),
      toDate: values.toDate ? toHttpFormat(values.toDate) : "",
      reportTemplate: uploadedFile,
    });
  };

  return (
    <>
      <Form onFinish={onFinish} form={form}>
        <Table columns={columns} dataSource={[{ key: 1 }]} pagination={false} />
      </Form>
      <Row justify="center" gutter={20} style={{ marginTop: "50px" }}>
        <Col>
          <Button onClick={history.goBack}>Отменить</Button>
        </Col>
        <Col>
          <Tooltip title={uploadedFile ? "" : "Необходимо загрузить файл"}>
            <Button type="primary" onClick={form.submit} disabled={!uploadedFile}>
              Сохранить
            </Button>
          </Tooltip>
        </Col>
      </Row>
    </>
  );
};

export default CreateDocumentTemplate;
